import moment from 'moment';

export const ANNOUNCEMENT_DEFAULT_FILTER = {
  title: undefined,
  sendDate: [moment().startOf('month').startOf('day'), moment().endOf('month').endOf('day')],
};

export const ANNOUNCEMENT_SEND_TYPE_EMAIL = 'SEND_EMAIL';
export const ANNOUNCEMENT_SEND_TYPE_APP = 'SEND_APP';